import { connect } from '../../../../common/react-redux';
import { featureOn } from '../../../../common/util/featureCheck';
import { withStudentAnalysisReportStatePresenter } from './withStudentAnalysisReportStatePresenter';
import { bindActionCreators, compose } from 'redux';
import { getStudentAnalyses, getStudentAnalysisFetchInProgress, getStudentAnalysisGenerationInProgress, getStudentAnalysisError, getStudentAnalysisStatusPollingInProgress } from '../../../../common/selectors/analyses';
import { setStudentAnalyses, setStudentAnalysisFetchInProgress, setStudentAnalysesGenerationInProgress, setStudentAnalysisError, setStudentAnalysisStatusPollingInProgress } from '../../../../common/actions/analyses';
import { getAnalysesStatus as fetchAnalysesStatus } from '../../../api/getAnalysesStatus';
import { fetchStudentAnalyses } from '../../../api/fetchStudentAnalyses';
import { addError } from '../../../../common/actions/alerts';
import { getActiveQuizId } from '../../../../common/selectors/quizzes';
import { getAnalysesExport } from '../../../api/getAnalysesExport';
var DEFAULT_POLLING_INTERVAL = 3000;
function mapStateToProps(state, ownProps) {
  return {
    studentAnalyses: getStudentAnalyses(state),
    fetchInProgress: getStudentAnalysisFetchInProgress(state),
    generationInProgress: getStudentAnalysisGenerationInProgress(state),
    statusPollingInProgress: getStudentAnalysisStatusPollingInProgress(state),
    analysisError: getStudentAnalysisError(state),
    activeQuizId: ownProps.activeQuizId || getActiveQuizId(state),
    getAnalysesExport: getAnalysesExport,
    fetchStudentAnalyses: fetchStudentAnalyses,
    fetchAnalysesStatus: fetchAnalysesStatus,
    pollingInterval: ownProps.pollingInterval || DEFAULT_POLLING_INTERVAL,
    exportEnabled: featureOn('student_analysis_csv'),
    allAttemptsEnabled: featureOn('student_analysis_multiple_attempts')
  };
}
export function mapDispatchToProps(dispatch, ownProps) {
  return {
    setStudentAnalyses: bindActionCreators(setStudentAnalyses, dispatch),
    setFetchInProgress: bindActionCreators(setStudentAnalysisFetchInProgress, dispatch),
    setGenerationInProgress: bindActionCreators(setStudentAnalysesGenerationInProgress, dispatch),
    setAnalysisError: bindActionCreators(setStudentAnalysisError, dispatch),
    addError: ownProps.addError || bindActionCreators(addError, dispatch),
    setStatusPollingInProgress: bindActionCreators(setStudentAnalysisStatusPollingInProgress, dispatch)
  };
}
var withStudentAnalysisReportState = compose(connect(mapStateToProps, mapDispatchToProps), withStudentAnalysisReportStatePresenter);
export default withStudentAnalysisReportState;